<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Liquidaciones</div>
        <span class="grey--text text--lighten-2">Relación de las últimas liquidaciones generadas</span>
      </div>
    </v-card-title>

    <div class="pa-2">
      <v-list>
        <template v-for="liquidacion in liquidaciones">
          <v-list-tile 
            :key="liquidacion.IDLIQUIDACION"
            :to="{ path: '/liquidaciones/' + liquidacion.IDLIQUIDACION + '/resumen'}">
            
              <v-list-tile-content>
                  <v-list-tile-title>{{ liquidacion.CONCEPTO }}</v-list-tile-title>            
              </v-list-tile-content>

          </v-list-tile>
        </template>
      </v-list>
    </div>
  </v-card>
 </template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { LIQUIDACIONES_REQUEST } from '../store/actions/liquidaciones';

  export default {
    name: 'BrwLiquidaciones',
    data: function () {
      return {}
    },
    created: function () {
      this.cargarLiquidaciones()
    },
    watch: {
      '$route': 'cargarLiquidaciones'
    },
    methods: {
      cargarLiquidaciones() {
        this.$store.dispatch(LIQUIDACIONES_REQUEST, {
          idComunidad: this.$store.state.comunidades.idComunidadActiva
        })
      }
    },
    computed: {
      ...mapState({
        liquidaciones: state => state.liquidaciones.liquidaciones
      })
    }
  }
</script>